/* Casa Manavay · oferta del Pack Dúo y Pack Triple destacada en el menú del celular y en el buscador (15 oct 2026, 21:50; precios 16 oct 2026).
   - Packs: borde y fondo lima, etiqueta "Oferta", ahorro real y precio por separado tachado. Ocupan todo el ancho en el buscador del computador.
   - Resto: subtítulo uniforme "1 frasco · 2 por $34.990" en cápsulas y "1 frasco · 2 por $36.990" en gomitas.
   - Al pasar el 9 de noviembre (23:59, hora de Chile) se quita lo de oferta solo.
   HALLOWEEN (19 oct 2026, 21:50): hasta el 31 oct 23:59 las 4 gomitas sueltas muestran "2 frascos $32.990 · Halloween" en el menú
   y en TODAS las tarjetas del sitio (colección, inicio, relacionados). El 1 nov vuelve solo a $36.990. */
(function(){
  if(window.cmNavOfOk) return; window.cmNavOfOk = true;
  var FIN = new Date('2026-11-09T23:59:59-03:00').getTime();
  var vigente = Date.now() < FIN;
  var HW = Date.now() < new Date('2026-11-01T00:00:00-03:00').getTime();
  var RE_GOM = /\/products\/(60-gomitas-|gomitas-vinagre)/i;
  var PACKS = {
    'duo-pack-nad-ashwagandha': { n: 'Pack Dúo NAD+ + Ashwagandha', t: 'Ahorras $14.990 · hasta el 9 de noviembre', a: '$49.980', s: '2 frascos · día y noche' },
    'pack-x3-nad-resveratrol-1000mg-60-caps': { n: 'Pack Triple NAD+ Resveratrol', t: 'Ahorras $31.980 · hasta el 9 de noviembre', a: '$74.970', s: '3 frascos · $14.330 c/u' }
  };
  function estilos(){
    if(document.getElementById('cm-nav-of-css')) return;
    var st = document.createElement('style'); st.id = 'cm-nav-of-css';
    st.textContent = '.cmn-capa .cmn-prods li.cmn-li--of{grid-column:1/-1}'
      + '.cmn-capa .cmn-prod.cmn-prod--of{position:relative;border:1.5px solid #C8F135!important;background:linear-gradient(100deg,rgba(200,241,53,.16),rgba(200,241,53,.03) 70%)!important;box-shadow:0 8px 26px rgba(200,241,53,.10)!important}'
      + '.cmn-capa .cmn-prod.cmn-prod--of small{color:#C8F135!important;font-weight:700!important;opacity:1!important}'
      + '.cmn-capa .cmn-prod.cmn-prod--of small i{display:block;font-style:normal;font-weight:500;color:rgba(255,255,255,.7)!important}'
      + '.cmn-capa .cmn-prod .cmn-of-tag{display:inline-block;margin-left:8px;padding:4px 8px;border-radius:5px;background:#C8F135;color:#0D0D0D!important;font:900 11.5px/1 "Barlow Condensed","Arial Narrow",sans-serif;letter-spacing:.08em;text-transform:uppercase;vertical-align:middle;white-space:nowrap}'
      + '.cmn-capa .cmn-prod.cmn-prod--of em{display:flex;flex-direction:column;align-items:flex-end;gap:2px}'
      + '.cmn-capa .cmn-prod.cmn-prod--of em s{font:600 12px/1 Inter,sans-serif;color:rgba(255,255,255,.5)!important;text-decoration:line-through}';
    document.head.appendChild(st);
  }
  function handle(a){ var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }
  function aplicar(){
    var links = document.querySelectorAll('.cmn-capa a.cmn-prod');
    if(!links.length) return;
    estilos();
    links.forEach(function(a){
      if(a.dataset.cmnOf) return; a.dataset.cmnOf = '1';
      var b = a.querySelector('b'), sm = a.querySelector('small'), em = a.querySelector('em');
      var h = handle(a);
      var p = PACKS[h];
      if(p){
        if(b){ b.textContent = p.n; }
        if(vigente){
          a.classList.add('cmn-prod--of');
          var li = a.closest('li'); if(li){ li.classList.add('cmn-li--of'); }
          if(b){ var tg = document.createElement('span'); tg.className = 'cmn-of-tag'; tg.textContent = 'Oferta'; b.appendChild(tg); }
          if(sm){ sm.innerHTML = ''; sm.appendChild(document.createTextNode(p.t)); var i = document.createElement('i'); i.textContent = p.s; sm.appendChild(i); }
          if(em && !em.querySelector('s')){ var s = document.createElement('s'); s.textContent = p.a; em.appendChild(s); }
        } else if(sm){ sm.textContent = p.s; }
      } else {
        var tag = b && b.querySelector('.cmn-tag'); if(tag){ tag.parentNode.removeChild(tag); }
        if(sm){
          if(/gomitas/i.test(h)){
            sm.textContent = HW ? '1 frasco · 2 por $32.990 · Halloween' : '1 frasco · 2 por $36.990';
            if(HW){ sm.style.setProperty('color', '#FF8A2A', 'important'); }
          } else { sm.textContent = '1 frasco · 2 por $34.990'; }
        }
      }
    });
  }
  /* Tarjetas de gomitas en todo el sitio (no dentro de la ficha del producto, que ya la cambia cm-halloween.js) */
  function tarjetas(){
    if(!HW || RE_GOM.test(location.pathname)) return;
    var cards = document.querySelectorAll('a[href*="/products/60-gomitas-"], a[href*="/products/gomitas-vinagre"]');
    cards.forEach(function(a){
      if(a.closest('.cmn-capa')) return;
      var w = document.createTreeWalker(a, NodeFilter.SHOW_TEXT, null), n, lista = [];
      while((n = w.nextNode())){ if(n.nodeValue.indexOf('$36.990') >= 0){ lista.push(n); } }
      lista.forEach(function(t){
        var v = t.nodeValue.split('$36.990').join('$32.990');
        if(v.indexOf('Halloween') < 0){ v = v.replace(/\s*$/, ' · Halloween'); }
        t.nodeValue = v;
        if(t.parentNode && t.parentNode.style){ t.parentNode.style.setProperty('color', '#FF8A2A', 'important'); }
      });
    });
  }
  function correr(){ aplicar(); tarjetas(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', correr); } else { correr(); }
  window.addEventListener('load', tarjetas);
})();